import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useT } from "@/context/I18nContext";
import AuthLayout from "@/components/auth/AuthLayout";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const t = useT();
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [token, setToken] = useState(sp.get("token") || "");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token: token.trim(), password });
      toast.success(t("auth.resetOk"));
      nav("/login", { replace: true });
    } catch (e) {
      setErr(errMsg(e, t("errors.generic")));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      eyebrow={t("auth.forgot")}
      title={t("auth.resetTitle")}
      subtitle={t("auth.resetSub")}
      footer={<Link to="/login" data-testid="reset-goto-login" className="text-sage-600 font-semibold hover:underline">← {t("auth.signIn")}</Link>}
    >
      <form onSubmit={onSubmit} className="space-y-4" data-testid="reset-form">
        <div>
          <Label htmlFor="rp-token">{t("auth.inviteToken").replace("Invite", "Reset")}</Label>
          <Input id="rp-token" data-testid="reset-token" required value={token} onChange={(e) => setToken(e.target.value)}
            className="mt-1.5 h-11 rounded-xl bg-white font-mono" />
        </div>
        <div>
          <Label htmlFor="rp-pw">{t("common.password")}</Label>
          <Input id="rp-pw" data-testid="reset-password" type="password" required minLength={10} value={password}
            onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11 rounded-xl bg-white" />
          <p className="text-xs text-ink-500 mt-1">{t("auth.passwordHint")}</p>
        </div>
        {err && <div className="rounded-xl bg-rust-500/10 border border-rust-500/20 text-rust-600 text-sm px-3 py-2" data-testid="reset-error">{err}</div>}
        <Button type="submit" data-testid="reset-submit" disabled={busy} className="w-full h-11 rounded-full bg-sage-500 hover:bg-sage-600 text-white font-medium">
          {busy ? t("common.loading") : t("common.save")}
        </Button>
      </form>
    </AuthLayout>
  );
}
